import type { JSX } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { SortableTableHead } from '@/shared/components/SortableTableHead';
import type { SortState } from '@/shared/types/table-filters.types';
import type { Candidate, CandidateStatus } from '../types/candidate.types';
import { CandidateRow } from './CandidateRow';

export interface CandidateTableProps {
  candidates: Candidate[];
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  onEdit: (candidate: Candidate) => void;
  onDelete: (id: string) => void;
  onStatusChange: (id: string, status: CandidateStatus) => void;
  onResendInvitation: (id: string) => void;
  onCopyLink: (shareId: string) => void;
}

const SORTABLE_HEADERS = [
  { key: 'name', label: 'Candidate', className: 'w-[250px]' },
  { key: 'country', label: 'Country' },
  { key: 'status', label: 'Status' },
  { key: 'consentGiven', label: 'Consent' },
  { key: 'createdAt', label: 'Created' },
];

export function CandidateTable({
  candidates,
  sort,
  onToggleSort,
  ...rowHandlers
}: CandidateTableProps): JSX.Element {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            {SORTABLE_HEADERS.map((header) => (
              <SortableTableHead
                key={header.key}
                columnKey={header.key}
                label={header.label}
                className={header.className}
                sort={sort}
                onToggleSort={onToggleSort}
              />
            ))}
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {candidates.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} className="h-24 text-center">
                No candidates found.
              </TableCell>
            </TableRow>
          ) : (
            candidates.map((candidate) => (
              <CandidateRow key={candidate.id} candidate={candidate} {...rowHandlers} />
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
